import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { TransactionTypeModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[TransactionType] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[TransactionType] Load items success', props<{ data: PaginationAdapter<TransactionTypeModel> }>());

// item
export const loadItem = createAction('[TransactionType] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[TransactionType] Load item success', props<{ item: TransactionTypeModel }>());
